// In src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import FeedbackBubble from './components/FeedbackBubble';


// Import ALL your providers here
import { MusicProvider } from "./context/MusicContext";
import { ProfileProvider } from "./context/ProfileContext";
import { AnimationProvider } from "./context/AnimationContext";
import { SearchProvider } from "./context/SearchContext";
import { Elements } from "@stripe/react-stripe-js";
import { Toaster } from 'react-hot-toast';
import { loadStripe } from "@stripe/stripe-js";
import { CartProvider } from './context/CartContext';
import { HelmetProvider } from 'react-helmet-async';
import LegalGate from "./components/miscellaneous/LegalGate";

// You should move your stripe key to a .env file, but for now this works
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Elements stripe={stripePromise}>
          <MusicProvider>
            <SearchProvider>
              <AnimationProvider>
                <ProfileProvider>
                  <LegalGate />
                  <CartProvider>
                    <App />
                    {/*<FeedbackBubble />*/}
                    <Toaster 
                      position="top-center"
                      toastOptions={{
                        duration: 4000,
                      }}
                    />
                  </CartProvider>
                </ProfileProvider>
              </AnimationProvider>
            </SearchProvider>
          </MusicProvider>
        </Elements>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();